import backBent30 from "src/assets/images/msd/back_bent_forward_30_degrees.png";
import backBent45 from "src/assets/images/msd/back_bent_forward_45_degrees.png";
import liftHeavy75 from "src/assets/images/msd/lifting_heavy_object.png";
import liftAboveShoulder from "src/assets/images/msd/lifting_above_shoulders.png";
import liftRepeat from "src/assets/images/msd/handling_boxes_cart.png";
import pinchGrip from "src/assets/images/msd/pinch_grip.png";
import wristDeviation30 from "src/assets/images/msd/wrist_deviation_30_degrees.png";
import wristDeviation45 from "src/assets/images/msd/wrist_deviation_45_degrees.png";
import precisionGrip from "src/assets/images/msd/precision_tool_use.png";
import cylindricalGrip from "src/assets/images/msd/cylindrical_grip.png";
import powerGrip from "src/assets/images/msd/stapler_grip.png";
import handImpact from "src/assets/images/msd/impact_tool_use.png";
import repetitiveMotion from "src/assets/images/msd/repetitive_sorting.png";
import keyingBasic from "src/assets/images/msd/keyboard_typing.png";
import vibrationModerate from "src/assets/images/msd/power_tool_use.png";
import vibrationHigh from "src/assets/images/msd/impact_tool_use.png";
import neckBent30 from "src/assets/images/msd/machine_operation_bent_neck.png";
import handsAboveHead from "src/assets/images/msd/overhead_installation.png";
import reachingOverhead from "src/assets/images/msd/overhead_harvesting.png";
import squatting from "src/assets/images/msd/squatting_posture.png";
import kneeling from "src/assets/images/msd/kneeling_digging.png";

type MsdRiskFactorPath = {
  path: string;
  displayName: string;
  image: string;
  description: string;
  thresholds: {
    propertyName: string;
    displayName: string;
    isHazard: boolean;
  }[];
};

export const msdLowBackRiskFactors: MsdRiskFactorPath[] = [
  {
    path: "posture.backBent30",
    displayName: "Back Bent Forward >30°",
    image: backBent30,
    description:
      "Working with the back bent forward more than 30° (without support or the ability to vary posture)",
    thresholds: [
      {
        propertyName: "backBent30_2hours",
        displayName: "More than 2 hours total per day",
        isHazard: false,
      },
      {
        propertyName: "backBent30_4hours",
        displayName: "More than 4 hours total per day",
        isHazard: true,
      },
    ],
  },
  {
    path: "posture.backBent45",
    displayName: "Back Bent Forward >45°",
    image: backBent45,
    description:
      "Working with the back bent forward more than 45° (without support or the ability to vary posture)",
    thresholds: [
      {
        propertyName: "backBent45_1hour",
        displayName: "More than 1 hour total per day",
        isHazard: false,
      },
      {
        propertyName: "backBent45_2hours",
        displayName: "More than 2 hours total per day",
        isHazard: true,
      },
    ],
  },
  {
    path: "force.lift75lb",
    displayName: "Lifting >75 lbs",
    image: liftHeavy75,
    description: "Lifting object weighing more than 75 pounds (34 Kg)",
    thresholds: [
      {
        propertyName: "lift75lb_once",
        displayName: "One or more times per day",
        isHazard: true,
      },
    ],
  },
  {
    path: "force.lift55lb",
    displayName: "Lifting >55 lbs",
    image: liftHeavy75,
    description: "Lifting object weighing more than 55 pounds (25 Kg)",
    thresholds: [
      {
        propertyName: "lift55lb_10times",
        displayName: "More than 10 times per day",
        isHazard: false,
      },
      {
        propertyName: "lift55lb_20times",
        displayName: "More than 20 times per day",
        isHazard: true,
      },
    ],
  },
  {
    path: "force.liftAwkward25lb",
    displayName: "Lifting >25 lbs Awkwardly",
    image: liftAboveShoulder,
    description:
      "Lifting objects weighing more than 25 lbs (12 kg) above shoulders, below knees or at arms length",
    thresholds: [
      {
        propertyName: "liftAwkward25lb_10pounds",
        displayName: "More than 10 pounds",
        isHazard: false,
      },
      {
        propertyName: "liftAwkward25lb_20pounds",
        displayName: "More than 20 pounds",
        isHazard: true,
      },
    ],
  },
  {
    path: "force.liftRepeat10lb",
    displayName: "Repetitive Lifting >10 lbs",
    image: liftRepeat,
    description:
      "Lifting objects weighing more than 10 pounds (4.5 Kg) if done more than twice per minute",
    thresholds: [
      {
        propertyName: "liftRepeat10lb_2hours",
        displayName: "More than 2 hours total per day",
        isHazard: false,
      },
      {
        propertyName: "liftRepeat10lb_4hours",
        displayName: "More than 4 hours total per day",
        isHazard: true,
      },
    ],
  },
];

export const msdHandWristRiskFactors: MsdRiskFactorPath[] = [
  {
    path: "pinch.pinch2lb",
    displayName: "Pinching >2 lbs",
    image: pinchGrip,
    description:
      "Pinching an unsupported object(s) weighing 2 or more pounds (1 Kg) per hand",
    thresholds: [
      {
        propertyName: "pinch2lb_2hours",
        displayName: "More than 2 hours total per day",
        isHazard: false,
      },
      {
        propertyName: "pinch2lb_4hours",
        displayName: "More than 4 hours total per day",
        isHazard: true,
      },
    ],
  },
  {
    path: "pinch.pinchDeviation",
    displayName: "Pinching with Wrist Deviation",
    image: wristDeviation30,
    description: "Pinching with wrist deviation",
    thresholds: [
      {
        propertyName: "pinchDeviation_3hours",
        displayName: "More than 3 hours total per day",
        isHazard: true,
      },
    ],
  },
  {
    path: "pinch.pinchRepetitive",
    displayName: "Repetitive Pinching",
    image: precisionGrip,
    description: "Pinching with highly repetitive motion",
    thresholds: [
      {
        propertyName: "pinchRepetitive_3hours",
        displayName: "More than 3 hours total per day",
        isHazard: true,
      },
    ],
  },
  {
    path: "grip.grip10lb",
    displayName: "Gripping >10 lbs",
    image: cylindricalGrip,
    description:
      "Gripping an unsupported objects(s) weighing 10 or more pounds (4.5 Kg) per hand",
    thresholds: [
      {
        propertyName: "grip10lb_2hours",
        displayName: "More than 2 hours total per day",
        isHazard: false,
      },
      {
        propertyName: "grip10lb_4hours",
        displayName: "More than 4 hours total per day",
        isHazard: true,
      },
    ],
  },
  {
    path: "grip.gripDeviation",
    displayName: "Gripping with Wrist Deviation",
    image: wristDeviation45,
    description: "Gripping with wrist deviation",
    thresholds: [
      {
        propertyName: "gripDeviation_3hours",
        displayName: "More than 3 hours total per day",
        isHazard: true,
      },
    ],
  },
  {
    path: "grip.gripRepetitive",
    displayName: "Repetitive Gripping",
    image: powerGrip,
    description: "Gripping with highly repetitive motion",
    thresholds: [
      {
        propertyName: "gripRepetitive_3hours",
        displayName: "More than 3 hours total per day",
        isHazard: true,
      },
    ],
  },
  {
    path: "motion.handWristRepetitiveMotion",
    displayName: "Repetitive Hand/Wrist Motion",
    image: repetitiveMotion,
    description:
      "Repeating the same motion with the elbows, wrists, or hands with little or no variation every few seconds",
    thresholds: [
      {
        propertyName: "handWristRepetitiveMotion_2hours",
        displayName: "More than 2 hours total per day",
        isHazard: false,
      },
      {
        propertyName: "handWristRepetitiveMotion_6hours",
        displayName: "More than 6 hours total per day",
        isHazard: true,
      },
    ],
  },
  {
    path: "motion.repetitiveWithForce",
    displayName: "Forceful Repetitive Motion",
    image: repetitiveMotion,
    description:
      "Repetition with high, forceful exertions with the hand(s) and wrist deviation",
    thresholds: [
      {
        propertyName: "repetitiveWithForce_2hours",
        displayName: "More than 2 hours total per day",
        isHazard: true,
      },
    ],
  },
  {
    path: "motion.keying",
    displayName: "Intensive Keying",
    image: keyingBasic,
    description: "Intensive keying",
    thresholds: [
      {
        propertyName: "keying_4hours",
        displayName: "More than 4 hours per day",
        isHazard: false,
      },
      {
        propertyName: "keying_7hours",
        displayName: "More than 7 hours per day",
        isHazard: true,
      },
    ],
  },
  {
    path: "motion.keyingDeviation",
    displayName: "Keying with Wrist Deviation",
    image: keyingBasic,
    description: "Intensive keying with wrist deviations",
    thresholds: [
      {
        propertyName: "keyingDeviation_4hours",
        displayName: "More than 4 hours total per day",
        isHazard: true,
      },
    ],
  },
  {
    path: "impact.handHammer",
    displayName: "Hand as Hammer",
    image: handImpact,
    description: "Using the hand (heel/base of palm) as a hammer",
    thresholds: [
      {
        propertyName: "handHammer_10perHour",
        displayName: "More than 10 times per hour",
        isHazard: false,
      },
      {
        propertyName: "handHammer_1perMinute",
        displayName: "More than 1 time per minute",
        isHazard: true,
      },
    ],
  },
  {
    path: "vibration.moderateVibration",
    displayName: "Moderate Vibration",
    image: vibrationModerate,
    description: "Using tools with moderate vibration levels",
    thresholds: [
      {
        propertyName: "moderateVibration_2hours",
        displayName: "More than 2 hours per day",
        isHazard: false,
      },
      {
        propertyName: "moderateVibration_4hours",
        displayName: "More than 4 hours per day",
        isHazard: true,
      },
    ],
  },
  {
    path: "vibration.highVibration",
    displayName: "High Vibration",
    image: vibrationHigh,
    description: "Using tools with high vibration levels",
    thresholds: [
      {
        propertyName: "highVibration_30min",
        displayName: "More than 30 minutes per day",
        isHazard: false,
      },
      {
        propertyName: "highVibration_1hour",
        displayName: "More than 1 hour per day",
        isHazard: true,
      },
    ],
  },
];

export const msdNeckShoulderRiskFactors: MsdRiskFactorPath[] = [
  {
    path: "neckPosture.neckBent30",
    displayName: "Neck Bent >30°",
    image: neckBent30,
    description:
      "Working with the neck bent more than 30 degrees (without support and without the ability to vary posture)",
    thresholds: [
      {
        propertyName: "neckBent30_2hours",
        displayName: "More than 2 hours total per day",
        isHazard: false,
      },
    ],
  },
  {
    path: "neckPosture.neckBent45",
    displayName: "Neck Bent >45°",
    image: neckBent30,
    description:
      "Working with the neck bent more than 45 degrees (without support and without the ability to vary posture)",
    thresholds: [
      {
        propertyName: "neckBent45_2hours",
        displayName: "More than 2 hours total per day",
        isHazard: false,
      },
      {
        propertyName: "neckBent45_4hours",
        displayName: "More than 4 hours total per day",
        isHazard: true,
      },
    ],
  },
  {
    path: "shoulderPosture.handsAboveHead",
    displayName: "Hands Above Head",
    image: handsAboveHead,
    description:
      "Working with the hand(s) above the head, or the elbows above the shoulders",
    thresholds: [
      {
        propertyName: "handsAboveHead_2hours",
        displayName: "More than 2 hours total per day",
        isHazard: false,
      },
      {
        propertyName: "handsAboveHead_4hours",
        displayName: "More than 4 hours total per day",
        isHazard: true,
      },
    ],
  },
  {
    path: "shoulderPosture.raisingHandsAboveHead",
    displayName: "Repeatedly Raising Hands",
    image: reachingOverhead,
    description:
      "Repeatedly raising the hand(s) above the head, or the elbow(s) above the shoulder(s) more than once per minute",
    thresholds: [
      {
        propertyName: "raisingHandsAboveHead_2hours",
        displayName: "More than 2 hours total per day",
        isHazard: false,
      },
      {
        propertyName: "raisingHandsAboveHead_4hours",
        displayName: "More than 4 hours total per day",
        isHazard: true,
      },
    ],
  },
  {
    path: "motion.neckShoulderRepetitiveMotion",
    displayName: "Repetitive Neck/Shoulder Motion",
    image: repetitiveMotion,
    description:
      "Repeating the same motion with the neck or shoulders with little or no variation every few seconds",
    thresholds: [
      {
        propertyName: "neckShoulderRepetitiveMotion_2hours",
        displayName: "More than 2 hours total per day",
        isHazard: false,
      },
      {
        propertyName: "neckShoulderRepetitiveMotion_6hours",
        displayName: "More than 6 hours total per day",
        isHazard: true,
      },
    ],
  },
];

export const msdKneeRiskFactors: MsdRiskFactorPath[] = [
  {
    path: "posture.squatting",
    displayName: "Squatting",
    image: squatting,
    description: "Squatting",
    thresholds: [
      {
        propertyName: "squatting_2hours",
        displayName: "More than 2 hours total per day",
        isHazard: false,
      },
      {
        propertyName: "squatting_4hours",
        displayName: "More than 4 hours total per day",
        isHazard: true,
      },
    ],
  },
  {
    path: "posture.kneeling",
    displayName: "Kneeling",
    image: kneeling,
    description: "Kneeling",
    thresholds: [
      {
        propertyName: "kneeling_2hours",
        displayName: "More than 2 hours total per day",
        isHazard: false,
      },
      {
        propertyName: "kneeling_4hours",
        displayName: "More than 4 hours total per day",
        isHazard: true,
      },
    ],
  },
  {
    path: "impact.kneeHammer",
    displayName: "Knee as Hammer",
    image: kneeling,
    description: "Using the knee as a hammer",
    thresholds: [
      {
        propertyName: "kneeHammer_10perHour",
        displayName: "More than 10 times per hour",
        isHazard: false,
      },
      {
        propertyName: "kneeHammer_1perMinute",
        displayName: "More than 1 time per minute",
        isHazard: true,
      },
    ],
  },
];

export const allMsdRiskFactors: MsdRiskFactorPath[] = [
  ...msdLowBackRiskFactors,
  ...msdHandWristRiskFactors,
  ...msdNeckShoulderRiskFactors,
  ...msdKneeRiskFactors,
];

export function findRiskFactorByPath(
  path: string,
): MsdRiskFactorPath | undefined {
  return allMsdRiskFactors.find((factor) => factor.path === path);
}
